import { useMemo } from 'react'
import { useCreditUsage } from 'hooks/useCreditUsage'
import { useShowNextGenContentPreferences } from 'hooks/useShowNextGenContentPreferences'
import { isVideo } from 'components/ImageMenu/utils'
import { AlmanacFileShowItem } from 'hooks/queries/files/types'

export const useNextGenChatMessageCost = (
  displayedFile: AlmanacFileShowItem | undefined | null,
): number | undefined => {
  const { usageCosts } = useCreditUsage()
  const { showNextGenContentPreferences } = useShowNextGenContentPreferences()

  return useMemo(() => {
    if (!displayedFile || !usageCosts || !showNextGenContentPreferences) return undefined

    if (displayedFile.is_carousel) {
      return usageCosts.still_image_credits_cost
    }

    if (
      isVideo({ url: displayedFile.source_media_info?.source_url, type: displayedFile.source_media_info?.mime_type })
    ) {
      return usageCosts.still_image_credits_cost + usageCosts.video_credits_cost
    }

    return usageCosts.still_image_credits_cost
  }, [displayedFile, usageCosts, showNextGenContentPreferences])
}
